/**
 * In ACC - when opening links inside ACC we want to use the same tab. Outside of ACC (BIM, etc.) - new tab.
 * @param url
 * @return {*}
 */
export default (url: string) =>
  new URL(window.location.href).origin ===
  new URL(url, window.location.origin).origin
    ? undefined
    : '_blank';
